module.exports = __webpack_public_path__ + "img/comment.5e1ebd74.svg";